import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["static"],
    _excluded2 = ["unmount"],
    _excluded3 = ["as", "children", "refName"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.object.from-entries.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Fragment as c, cloneElement as T, createElement as F, forwardRef as h, isValidElement as P } from "react";
import { match as b } from "./match.js";

var x = function (n) {
  return n[n.None = 0] = "None", n[n.RenderStrategy = 1] = "RenderStrategy", n[n.Static = 2] = "Static", n;
}(x || {}),
    R = function (e) {
  return e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e;
}(R || {});

function _(_ref) {
  var r = _ref.ourProps,
      t = _ref.theirProps,
      e = _ref.slot,
      n = _ref.defaultTag,
      a = _ref.features,
      _ref$visible = _ref.visible,
      s = _ref$visible === void 0 ? !0 : _ref$visible,
      l = _ref.name;
  var o = y(t, r);
  if (s) return f(o, e, n, l);
  var d = a != null ? a : 0;

  if (d & 2) {
    var _o$static = o.static,
        i = _o$static === void 0 ? !1 : _o$static,
        u = _objectWithoutProperties(o, _excluded);

    if (i) return f(u, e, n, l);
  }

  if (d & 1) {
    var _b;

    var _o$unmount = o.unmount,
        _i = _o$unmount === void 0 ? !0 : _o$unmount,
        _u = _objectWithoutProperties(o, _excluded2);

    return b(_i ? 0 : 1, (_b = {}, _defineProperty(_b, 0, function _() {
      return null;
    }), _defineProperty(_b, 1, function _() {
      return f(_objectSpread(_objectSpread({}, _u), {}, {
        hidden: !0,
        style: {
          display: "none"
        }
      }), e, n, l);
    }), _b));
  }

  return f(o, e, n, l);
}

function f(r) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var e = arguments.length > 2 ? arguments[2] : undefined;
  var n = arguments.length > 3 ? arguments[3] : undefined;

  var _m = m(r, ["unmount", "static"]),
      _m$as = _m.as,
      a = _m$as === void 0 ? e : _m$as,
      s = _m.children,
      _m$refName = _m.refName,
      l = _m$refName === void 0 ? "ref" : _m$refName,
      o = _objectWithoutProperties(_m, _excluded3),
      d = r.ref !== void 0 ? _defineProperty({}, l, r.ref) : {},
      i = typeof s == "function" ? s(t) : s;

  o.className && typeof o.className == "function" && (o.className = o.className(t));
  var u = {};

  if (a === c && Object.keys(g(o)).length > 0) {
    if (!P(i) || Array.isArray(i) && i.length > 1) throw new Error(['Passing props on "Fragment"!', "", "The current component <".concat(n, " /> is rendering a \"Fragment\"."), "However we need to passthrough the following props:", Object.keys(o).map(function (p) {
      return "  - ".concat(p);
    }).join("\n"), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map(function (p) {
      return "  - ".concat(p);
    }).join("\n")].join("\n"));
    return T(i, Object.assign({}, y(i.props, g(m(o, ["ref"]))), u, d));
  }

  return F(a, Object.assign({}, m(o, ["ref"]), a !== c && d, a !== c && u), i);
}

function y() {
  var n;

  for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
    r[_key] = arguments[_key];
  }

  if (r.length === 0) return {};
  if (r.length === 1) return r[0];
  var t = {},
      e = {};

  for (var _i2 = 0, _r = r; _i2 < _r.length; _i2++) {
    var a = _r[_i2];

    for (var s in a) {
      s.startsWith("on") && typeof a[s] == "function" ? ((n = e[s]) != null || (e[s] = []), e[s].push(a[s])) : t[s] = a[s];
    }
  }

  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map(function (a) {
    return [a, void 0];
  })));

  var _loop = function _loop(_a) {
    Object.assign(t, _defineProperty({}, _a, function (s) {
      var o = e[_a];

      for (var _len2 = arguments.length, l = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        l[_key2 - 1] = arguments[_key2];
      }

      var _iterator = _createForOfIteratorHelper(o),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var d = _step.value;
          if (s.defaultPrevented) return;
          d.apply(void 0, [s].concat(l));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }));
  };

  for (var _a in e) {
    _loop(_a);
  }

  return t;
}

function H(r) {
  var t;
  return Object.assign(h(r), {
    displayName: (t = r.displayName) != null ? t : r.name
  });
}

function g(r) {
  var t = Object.assign({}, r);

  for (var e in t) {
    t[e] === void 0 && delete t[e];
  }

  return t;
}

function m(r) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var e = Object.assign({}, r);

  var _iterator2 = _createForOfIteratorHelper(t),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var n = _step2.value;
      n in e && delete e[n];
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return e;
}

export { x as Features, R as RenderStrategy, g as compact, H as forwardRefWithAs, _ as render };